import { render, staticRenderFns } from "./Tributacao.vue?vue&type=template&id=1ce046f1&scoped=true"
import script from "./Tributacao.vue?vue&type=script&lang=js"
export * from "./Tributacao.vue?vue&type=script&lang=js"
import style0 from "./Tributacao.vue?vue&type=style&index=0&id=1ce046f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce046f1",
  null
  
)

export default component.exports